import Vue from 'vue'
import { animeMixin } from '@/utils/index'

Vue.use(animeMixin)
